import React from 'react'

interface FilterFormWrapperProps {
  onSearch: () => void
  children: React.ReactNode
  className?: string
}

export function FilterFormWrapper({
  onSearch,
  children,
  className = '',
}: FilterFormWrapperProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
  }

  const handleKeyDownCapture = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      const activeElement = document.activeElement
      if (activeElement instanceof HTMLElement) {
        e.preventDefault()
        e.stopPropagation()
        activeElement.blur()
      }
      onSearch()
    }
  }

  return (
    <div
      onKeyDownCapture={handleKeyDownCapture} 
      className={className}
    >
      <form onSubmit={handleSubmit} className="w-full">
        {children}
      </form>
    </div>
  )
}
